var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ethereum (ETH)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ethereum (ETH)_2",
    cx: 24,
    cy: 24.5,
    r: 24,
    fill: "#EDF0F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ethereum (ETH)_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ethereum (ETH)_4",
    d: "M23.9346 10.1L23.7437 10.7485V29.5652L23.9346 29.7557L32.6689 24.5927L23.9346 10.1Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ethereum (ETH)_5",
    d: "M23.9347 10.1L15.2002 24.5927L23.9347 29.7557V20.6226V10.1Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ethereum (ETH)_6",
    d: "M23.9348 31.4094L23.8271 31.5406V38.2434L23.9348 38.5575L32.6744 26.2491L23.9348 31.4094Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ethereum (ETH)_7",
    d: "M23.9347 38.5575V31.4094L15.2002 26.2491L23.9347 38.5575Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ethereum (ETH)_8",
    d: "M23.9346 29.7557L32.6689 24.5927L23.9346 20.6226V29.7557Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ethereum (ETH)_9",
    d: "M15.2002 24.5927L23.9347 29.7557V20.6226L15.2002 24.5927Z",
    fill: "#393939"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/Ethereum.912d50e58d47612ea2d19c7d0da2eaff.svg";
export { ForwardRef as ReactComponent };